
import { computed, defineComponent } from 'vue';
import { LockOpenOutline as LockIcon, MailOutline as SendIcon } from '@vicons/ionicons5';

export default defineComponent({
  name: 'ResponseActions',
  components: { LockIcon, SendIcon },
  props: {
    response: {
      type: Object,
      required: true
    }
  },
  emits: ['unlock', 'resend'],
  methods: {
    unlockResponse() {
      this.$emit('unlock', this.response);
    },
    resendResponse() {
      this.$emit('resend', this.response);
    }
  },
  setup(props) {
    const unlocked = computed(() => !props.response.completedOn);

    return {
      unlocked
    };
  }
});
